<template>
  <section>
  <div id="navBar">
    <template v-if="$route.path == '/events'">
    <div class="navItemLeft"><router-link to="settings"><img src="../assets/images/App_SettingsIcon.png" height="24" class="colorizePrimaryDark"/></router-link></div>
    </template>
    <template v-else-if="$route.path == '/settings'">
      <div class="navItemLeft"><router-link to="events"><b>&lt;</b> Back</router-link></div>
      <div class="navItemMiddle"><h5>Settings</h5></div>
    </template>
    <template v-else-if="$route.path == '/messages'">
      <div class="navItemLeft"><router-link to="event"><b>&lt;</b> Back</router-link></div>
      <div class="navItemMiddle"><h5>Messages</h5></div>
    </template>
    <template v-else>
      <div class="navItemLeft"><router-link to="events"><b>&lt;</b> Back</router-link></div>
    </template>
  </div>
  </section>
</template>

<script>
  import { mapState } from "vuex"
  const fb = require("../firebaseConfig.js")

  export default {
    computed: {
      ...mapState([ "appUser" ])
    },
    methods: {
      signOut() {
        fb.auth.signOut().then(() => {
          this.$store.dispatch('clearData')
          this.$router.push('/getstarted')
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue